/*
 * @Author: cgh
 * @Date: 2022-08-01 10:49:32
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-01 16:07:59
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const pgyqManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfpg/pgyq`, { params: params }); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfpg/pgyq`, fd); },

  // 修改
  update: (id, fd) => { return axios.put(`${iffApi}/xfpg/pgyq/${id}`, fd); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfpg/pgyq/${id}`); },

  // 详情
  getDetail: (id) => { return axios.get(`${iffApi}/xfpg/pgyq/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfpg/pgyq/exportTj`, { responseType: 'blob', params }); }
};
